export default __webpack_public_path__ + "static/media/pan_service.626f8207.png";